// Module-based permission constants
// Stored on user as: { module_key: ["view","add","edit",...] }

export const PERMISSION_MODULES = [
  { key: 'users',        label: 'Users',        actions: ['view', 'add', 'edit', 'delete'] },
  { key: 'products',     label: 'Products',     actions: ['view', 'add', 'edit', 'delete', 'export'] },
  { key: 'inventory',    label: 'Inventory',    actions: ['view', 'add', 'edit', 'delete', 'export'] },
  { key: 'locations',    label: 'Locations',    actions: ['view', 'add', 'edit', 'delete'] },
  { key: 'pick_lists',   label: 'Pick Lists',   actions: ['view', 'add', 'edit', 'delete', 'export'] },
  { key: 'reports',      label: 'Reports',      actions: ['view', 'export'] },
  { key: 'scanner',      label: 'Scanner',      actions: ['view'] },
  { key: 'categories',   label: 'Categories',   actions: ['view', 'add', 'edit', 'delete'] },
  { key: 'transactions', label: 'Transactions', actions: ['view', 'add', 'export'] },
  { key: 'suppliers',    label: 'Suppliers',    actions: ['view', 'add', 'edit', 'delete'] },
  { key: 'units',        label: 'Units',        actions: ['view', 'add', 'edit', 'delete'] },
  { key: 'settings',     label: 'Settings',     actions: ['view', 'edit'] },
  { key: 'stock_audit',  label: 'Stock Audit',  actions: ['view', 'add', 'edit', 'delete', 'finalize', 'update_inventory'] },
  { key: 'invoice',      label: 'Invoice',      actions: ['view', 'add', 'edit', 'delete', 'email', 'export'] }
];

export const ACTION_LABELS = {
  view: 'View',
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  export: 'Export',
  finalize: 'Finalize',
  email: 'Email',
  update_inventory: 'Update Inventory'
};

// Sensible defaults for non-admin (staff) users
export const DEFAULT_STAFF_PERMISSIONS = {
  users: [],
  products: ['view'],
  inventory: ['view', 'add', 'edit'],
  locations: ['view'],
  pick_lists: ['view', 'add', 'edit'],
  reports: ['view'],
  scanner: ['view'],
  categories: ['view'],
  transactions: ['view', 'add'],
  suppliers: ['view'],
  units: ['view'],
  settings: [],
  stock_audit: ['view'],
  invoice: ['view']
};

// All permissions ON (used to display admin chips fully selected)
export const ALL_PERMISSIONS_ON = PERMISSION_MODULES.reduce((acc, m) => {
  acc[m.key] = [...m.actions];
  return acc;
}, {});

/**
 * Check whether a user has a specific permission on a module/action.
 * Admins always pass. Staff is checked against the per-user `permissions` dict.
 */
export const hasPermission = (user, moduleKey, action) => {
  if (!user) return false;
  if (user.role === 'admin') return true;
  const modulePerms = user.permissions?.[moduleKey];
  if (!Array.isArray(modulePerms)) return false;
  return modulePerms.includes(action);
};
